// #genai Phase 2 empty state — pixel-matched to Figma:
//   Desktop empty            : 269:20209
//   Desktop "Add Payment Method" opened (dropdown menu) : 630:31658
//   Mobile empty             : 269:20315
//   Mobile opened (bottom-sheet drawer)                 : 305:26485
// Rendered on /billing-information when the ENABLE_MULTI_PAYMENT_METHODS flag is ON and no
// payment method is saved. The "Add Payment Method" button (shared with the saved list) opens a
// payment-type menu offering "Bank (preferred)" and "Credit Card", which route to the dedicated
// add-ACH / add-card pages.
import React from 'lib/react';
import { EVGrid, EVTypography } from 'lib/components';
import { useTranslation } from 'lib/translation';
import AddPaymentMethodButton from '../AddPaymentMethodButton';
import BillingEmptyStateStyles from './BillingEmptyStateStyles';

function BillingEmptyState() {
  const { t } = useTranslation();
  const classes = BillingEmptyStateStyles();

  return (
    <EVGrid className={classes.container}>
      <EVGrid className={classes.empty}>
        <EVGrid className={classes.header}>
          <EVTypography className={classes.title}>
            {t('billing_information__no_payment_method_title')}
          </EVTypography>
          <EVTypography className={classes.message}>
            {t('billing_information__no_payment_method_message')}
          </EVTypography>
        </EVGrid>

        <AddPaymentMethodButton id="add-payment-method-btn" />
      </EVGrid>
    </EVGrid>
  );
}

export default BillingEmptyState;
